import { AddOnServiceOrderItem } from '@spike/order-model';
import { FunctionComponent } from 'react';
import OrderItem from './OrderItem';

export interface AddOnServiceItemProps {
    addOnServiceItem: AddOnServiceOrderItem;
    className?: string;
}

export const AddOnServiceItem: FunctionComponent<AddOnServiceItemProps> = props => {
    return (
        <OrderItem
            type="Add-On"
            orderItem={props.addOnServiceItem.orderItem}
            staff={props.addOnServiceItem.staff}
            className={props.className}
        />
    );
};

export default AddOnServiceItem;
